import {Pipe, PipeTransform} from '@angular/core';
import {RedirectToEnum} from '../../enums/sphere';
import {IResponseRequiredMeasures} from '../../models/measurement';

@Pipe({
  name: 'requiredMeasurementsTranslate'
})
export class RequiredMeasurementsTranslatePipe implements PipeTransform {
  redirectToEnum = RedirectToEnum;
  transform(measurement: {}, rules?: any): IResponseRequiredMeasures {
    const data: IResponseRequiredMeasures = {
      text: '-',
      route: RedirectToEnum.INFO
    };
    const value = Object.keys(measurement)[0];
    switch (value) {
      case 'weight' : {
        data.text = 'Peso';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'height' : {
        data.text = 'Altura';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'birthdate' : {
        data.text = (rules?.age?.minAge >= 0 && rules?.age?.maxAge >= 0) ? 'Edad entre ' + rules.age.minAge + ' y ' + rules.age.maxAge + ' años' : 'Edad';
        data.route = this.redirectToEnum.INFO;
        break;
      }
      case 'hip_circumference': {
        data.text = 'Perímetro cadera';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'waist_circumference': {
        data.text = 'Perímetro cintura';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'mass': {
        data.text = 'Masa';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'size': {
        data.text = 'tamaño';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'anterior_thigh_fold': {
        data.text = 'Pliegue del muslo anterior';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'tricipital_skin_fold': {
        data.text = 'Pliegue tricipital';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'subscapular_skin_fold': {
        data.text = 'Pliegue subescapular';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'fat_mass': {
        data.text = 'Grasa corporal';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'abdominal_skin_fold': {
        data.text = 'Pliegue abdominal';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'middle_axillary_skin_fold': {
        data.text = 'Pliegue axilar medio';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'imc': {
        data.text = 'imc';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'waist_to_hip_ratio': {
        data.text = 'Relación cintura-cadera';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'ideal_weight': {
        data.text = 'Peso ideal';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'gmb': {
        data.text = 'Gasto metabólico basal';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'tmb': {
        data.text = 'Tasa metabólica basal';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'geb': {
        data.text = 'Gasto energético basal';
        data.route = this.redirectToEnum.MEASUREMENTS;
        break;
      }
      case 'age': {
        data.text = 'Edad';
        data.route = this.redirectToEnum.INFO;
        break;
      }
      case 'physicalLevelActivity': {
        data.text = 'Nivel de actividad física';
        data.route = this.redirectToEnum.PHYSICAL_ACTIVITY;
        break;
      }
      default: {
        data.text = '-';
        data.route = this.redirectToEnum.INFO;
      }
    }
    return data;
  }

}
